import { Link } from "react-router-dom";
import TopBar from "@/components/TopBar";
import WhatsAppBadge from "@/components/WhatsAppBadge";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_dc295ef5-578e-436e-93fb-367679b984e5/artifacts/owgk1nux_tandaa_logo.png";

const PACKAGES = [
  { id: "bronze", name: "Bronze", speed: 25,  tier: "Fast Enough", price: "2,399", num: "01" },
  { id: "silver", name: "Silver", speed: 50,  tier: "Very Fast",  price: "3,599", num: "02", popular: true },
  { id: "gold",   name: "Gold",   speed: 100, tier: "Overkill", price: "6,999", num: "03" },
];

export default function Home() {
  return (
    <div data-testid="home-page">
      <TopBar active="home" sticky />

      <main className="tn-shell">
        {/* HERO */}
        <section className="tn-hero" data-testid="hero-block">
          <div className="tn-hero-grid">
            <div className="tn-hero-text">
              <div className="tn-eyebrow tn-hero-eyebrow">/ KILIFI · COASTAL KENYA · EST. 2019</div>
              <h1 className="tn-hero-h1" data-testid="hero-h1">
                CONNECTIVITY
                <br />
                <span className="slash" data-testid="hero-slash-2">// </span>AS IT SHOULD BE.
              </h1>
              <div className="sub">
                Tandaa Networks — fibre &amp; fixed-wireless built for the coast.
                Free install. Two months up front. No nonsense.
              </div>
              <div className="tn-hero-ctas">
                <Link to="/coverage.html" className="tn-btn is-accent tn-hero-btn" data-testid="hero-coverage-cta">
                  Check Coverage →
                </Link>
                <Link to="/order.html" className="tn-btn tn-hero-btn" data-testid="hero-order-cta">
                  Direct Order →
                </Link>
              </div>
            </div>

            <aside className="tn-hero-logo-card" data-testid="hero-logo-card">
              <div className="tn-hero-logo-tile">
                <img src={LOGO_URL} alt="Tandaa Networks logo" />
              </div>
              <div className="tn-hero-logo-meta">
                <div className="k">Tagline</div>
                <div className="v">Redefining Connectivity</div>
                <div className="k">Channel</div>
                <WhatsAppBadge
                  testid="hero-whatsapp-badge"
                  className="tn-hero-wa-badge"
                />
                <div className="k">Support</div>
                <div className="v">support@tandaa.africa</div>
                <a
                  href="tel:+254730729729"
                  className="tn-btn tn-hero-contact-btn"
                  data-testid="hero-call-us-btn"
                >
                  Call us: +254 730 729 729 →
                </a>
              </div>
            </aside>
          </div>

          <div className="tn-meta">
            <div>
              <span className="k">Hq</span>
              <span className="v">Kilifi, KE</span>
            </div>
            <div>
              <span className="k">Backbone</span>
              <span className="v">Mambrui → Vanga</span>
            </div>
            <div>
              <span className="k">Install</span>
              <span className="v">0 KES</span>
            </div>
            <div>
              <span className="k">Channel</span>
              <span className="v">WhatsApp Direct</span>
            </div>
          </div>
        </section>

        {/* PRICING MATRIX */}
        <section className="tn-section" data-testid="pricing-matrix">
          <div className="tn-section-head">
            <div>
              <div className="tn-eyebrow">/01 — Packages</div>
              <h2 className="tn-h2">The No-Nonsense Matrix</h2>
            </div>
            <div className="tn-eyebrow">All prices in KES · per month</div>
          </div>

          <div className="tn-matrix" role="table" aria-label="Internet packages">
            {PACKAGES.map((p) => (
              <div
                key={p.id}
                className={`tn-pkg ${p.popular ? "is-popular" : ""}`}
                role="row"
                data-testid={`pkg-${p.id}`}
              >
                {p.popular && <span className="tag" data-testid="pkg-popular-tag">Popular</span>}
                <div className="num">PKG / {p.num}</div>
                <div className="name">{p.name}</div>
                <div className="speed" data-testid={`pkg-${p.id}-speed`}>
                  <span className="speed-label">Speed</span>
                  <span className="speed-value">
                    <s className="speed-num" data-testid={`pkg-${p.id}-speed-num`}>{p.speed} Mbps</s>
                    <b className="speed-tier" data-testid={`pkg-${p.id}-tier`}>{p.tier}</b>
                  </span>
                </div>
                <div className="price">
                  {p.price} <small>KES / month</small>
                </div>
                <Link
                  to={`/order.html?plan=${p.id}`}
                  className="tn-pkg-cta"
                  data-testid={`pkg-${p.id}-cta`}
                >
                  Choose {p.name} →
                </Link>
              </div>
            ))}
          </div>

          <div className="tn-rule-block" data-testid="rule-block">
            <div className="col">
              <div className="k">Installation</div>
              <div className="v">0 KES <u>Free</u></div>
            </div>
            <div className="col">
              <div className="k">Activation Requirement</div>
              <div className="v">2-Month Prepayment</div>
            </div>
          </div>

          <Link
            to="/coverage.html"
            className="tn-cta"
            data-testid="proceed-coverage-cta"
          >
            Proceed to Coverage Map &amp; Order
            <span className="arrow">→</span>
          </Link>
        </section>

        {/* PROCESS */}
        <section className="tn-section" data-testid="how-block">
          <div className="tn-section-head">
            <div>
              <div className="tn-eyebrow">/02 — Process</div>
              <h2 className="tn-h2">Three Steps. Zero Friction.</h2>
            </div>
          </div>
          <div className="tn-matrix">
            <div className="tn-pkg">
              <div className="num">STEP / 01</div>
              <div className="name" style={{ fontSize: 22 }}>Check Coverage</div>
              <p className="tn-step-body">
                Open the coverage map. Your GPS pin drops automatically — see if you&apos;re inside an
                active 50-meter wayleave corridor or a hub coverage circle.
              </p>
            </div>
            <div className="tn-pkg">
              <div className="num">STEP / 02</div>
              <div className="name" style={{ fontSize: 22 }}>Authorize Position</div>
              <p className="tn-step-body">
                Tap <i>Request Service Here</i> — the pin and your plan choice ride straight into
                dispatch via WhatsApp. No call centre. No portals.
              </p>
            </div>
            <div className="tn-pkg">
              <div className="num">STEP / 03</div>
              <div className="name" style={{ fontSize: 22 }}>Free Install</div>
              <p className="tn-step-body">
                Technician runs the drop cable. Zero hardware fee. Activation needs two months
                prepaid up front — that&apos;s the only ask.
              </p>
            </div>
          </div>
        </section>
      </main>

      <footer className="tn-foot" data-testid="footer">
        <div>
          <span className="tn-logo-tile tn-logo-tile-sm" aria-hidden="true">
            <img src={LOGO_URL} alt="" />
          </span>
          Tandaa Networks Ltd · Kilifi, Kenya
        </div>
        <div>WhatsApp +254 730 729 729</div>
        <div>support@tandaa.africa</div>
      </footer>
    </div>
  );
}
